export const addClient = (client) => ({
  type: 'ADD_CLIENT',
  payload: client,
});

export const setClients = (clients) => ({
  type: 'SET_CLIENTS',
  payload: clients,
});

export const updateClient = (client) => ({
  type: 'UPDATE_CLIENT',
  payload: client, // client should include the id
});

export const setError = (error) => ({
  type: 'SET_ERROR',
  payload: error,
});
